import getters from './getters';
import mutations from './mutations';

const state = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/hardware/VuexTable/index.js